export default __webpack_public_path__ + "static/1610-7f5cd0e84c902a463b92817620081df2.gif";